export const PRECISION = 10;
export const STORAGE_DEBOUNCE_MS = 100;
export const DEFAULT_KEYBOARD_STEP = 10;
export const STORAGE_KEY_PREFIX = "schism:";
